import React, { useEffect, useState } from 'react';
import { Route, Routes, useParams } from 'react-router-dom';
import { Loader, Tabs } from '@itds/elements/index.js';
import { Alert } from '@itds/elements/index.js';

import Config from '@/config';

import EmbedCode from '@brokerage/pages/agencies/form_engines/EmbedCode';
import General from '@brokerage/pages/agencies/form_engines/General';
import LimitCarriers from '@brokerage/pages/agencies/form_engines/LimitCarriers';
import ThemeOptions from '@brokerage/pages/agencies/form_engines/ThemeOptions';

import H1 from '@brokerage/components/H1';

import { Api } from '@brokerage/utils/Api';

export const Show = () => {
  const params = useParams();
  const hash = window.location.hash;

  const [error_message, setErrorMessage] = useState();
  const [success_message, setSuccessMessage] = useState();
  const [loading, setLoading] = useState(true);
  const [form_engine, setFormEngine] = useState({});

  useEffect(() => {
    loadFormEngine();
  }, []);

  const loadFormEngine = () => {
    setLoading(true);

    Api.loadFormEngine(params.id).then(({ data }) => {
      setFormEngine(data);
      setLoading(false);
    });
  };

  const saveFormEngine = payload => {
    window.scrollTo(0, 0);

    setLoading(true);

    Api.updateFormEngine(params.id, payload)
      .then(({ data }) => {
        setFormEngine(data);
        setLoading(false);
        setSuccessMessage('Form Engine updated successfully');

        setTimeout(() => {
          setSuccessMessage(null);
        }, 2000);
      })
      .catch(() => {
        setLoading(false);
        setErrorMessage('Unable to update Form Engine');

        setTimeout(() => {
          setErrorMessage(null);
        }, 2000);
      });
  };

  const child_props = {
    form_engine,
    loadFormEngine,
    saveFormEngine,
    setErrorMessage,
    setFormEngine,
    setSuccessMessage
  };

  return loading ? (
    <Loader />
  ) : (
    <>
      {error_message ? <Alert type='error'>{error_message}</Alert> : null}
      {success_message ? <Alert type='success'>{success_message}</Alert> : null}

      <H1>{form_engine.name}</H1>

      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <Tabs
          tabs={[
            {
              label: 'General',
              to: ' ',
              isActive:
                hash.slice(-1) === `${form_engine.id}`.slice(-1) || hash.slice(-1) === '/'.slice(-1)
            },
            {
              label: 'Limit Carriers',
              to: 'limit_carriers',
              isActive: hash.includes('limit_carriers')
            },
            {
              label: 'Theme Options',
              to: 'theme_options',
              isActive: hash.includes('theme_options')
            },
            {
              label: 'Preview',
              onClick: () =>
                window.open(`${Config.FORM_ENGINE_URL}preview.html?token=${form_engine.guid}`)
            },
            {
              label: 'Embed Code',
              to: 'embed_code',
              isActive: hash.includes('embed_code')
            }
          ]}
          vertical={true}
        />

        <div style={{ flex: 1, paddingLeft: 40 }}>
          <Routes>
            <Route element={<General {...child_props} />} index={true} />
            <Route element={<LimitCarriers {...child_props} />} path='limit_carriers' />
            <Route element={<ThemeOptions {...child_props} />} path='theme_options' />
            <Route element={null} path='preview' />
            <Route element={<EmbedCode {...child_props} />} path='embed_code' />
          </Routes>
        </div>
      </div>
    </>
  );
};
